import { WhatsappAuthLinkTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const WhatsappAuthLinkTrackingSchema: Record<
  WhatsappAuthLinkTrackingPoint,
  string
> = {
  [WhatsappAuthLinkTrackingPoint.PageView]:
    'de8ce640-9a47-4a30-97b5-22d8523c364f',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkOpenWhatsappClick]:
    '4f5a5896-e611-4dad-92c0-eedf27991c80',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkHelpClick]:
    '9721fb66-51ac-4c97-9920-8e6e0e48296a',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkBackButton]:
    '5980e026-c167-4366-8dcb-975b3aa3f416',
  [WhatsappAuthLinkTrackingPoint.ResendWhatsappAuthLinkImpression]:
    '5d39bf72-d1cb-48a9-a158-0851210473f5',
  [WhatsappAuthLinkTrackingPoint.ResendWhatsappAuthLinkClick]:
    '4f0a0d54-3d81-4ae8-bac1-29c6a44eda17',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkTryAnotherMethodClick]:
    '43d20bbc-d24b-4e8a-9b95-d693b06defbf',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkTryAnotherMethodImpression]:
    'd2fa1f82-eb4d-41dc-9dc8-938d9868de9e',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithOtherMethodImpression]:
    'a2cea549-d309-4508-adab-602ba81d1f04',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithOtherMethodsClick]:
    'a65e60c2-dd50-48db-8916-1ed2f02df1e2',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPhoneImpression]:
    '84a1fe31-d8f6-4309-9d5a-c284cc8ca1ff',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPhoneClick]:
    '834e2c13-2199-4fbf-bc37-5eb9c66139b0',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithBiometricsImpression]:
    '227c73ca-d075-478d-89da-123fcceecac6',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithBiometricsClick]:
    '94e2f021-623f-41c5-b49c-42fdfbad163b',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPasswordImpression]:
    '1631b8ae-958b-4d85-b01e-f97b865f7555',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPasswordClick]:
    'c9cdc5d5-7ae2-4406-90af-5ffe1e4bd9fb',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithQuickLoginClick]:
    '6ce2f83e-f950-4caa-b94e-5eca64bcea67',
};

export const getWhatsappAuthLinkPageTypeAndSchema = (
  trackingPoint: WhatsappAuthLinkTrackingPoint
) => {
  return {
    page_type: PageType.WhatsappAuthLink,
    schema: WhatsappAuthLinkTrackingSchema[trackingPoint],
  };
};
